import { Injectable } from '@angular/core';

export enum CoreMobileEvents {
  tokenUpdated = 'tokenUpdated',
  tokenExpired = 'tokenExpired',
}

@Injectable({ providedIn: 'root' })
export class MobileEventsService {
  get isAndroidWebView(): boolean {
    if (Boolean((window as any).Android)) {
      return true;
    }

    const ua = navigator.userAgent;
    return /Android/.test(ua) && /wv/.test(ua);
  }

  get isIosWebView(): boolean {
    return Boolean((window as any).webkit?.messageHandlers?.swiftHandler);
  }

  get isReactNativeWebView(): boolean {
    return Boolean((window as any).ReactNativeWebView);
  }

  get isWebView(): boolean {
    return this.isAndroidWebView || this.isIosWebView || this.isReactNativeWebView;
  }

  tokenUpdated(token: string): void {
    if (this.isIosWebView) {
      this.sendIosEvent(CoreMobileEvents.tokenUpdated, token);
    }
    if (this.isAndroidWebView) {
      this.sendAndroidEvent().tokenUpdated(token);
    }
  }

  tokenExpired(): void {
    if (this.isIosWebView) {
      this.sendIosEvent(CoreMobileEvents.tokenExpired);
    }
    if (this.isAndroidWebView) {
      this.sendAndroidEvent().tokenExpired();
    }
  }

  protected sendIosEvent(name: string, data?: number | string | object): void {
    const handler = (window as any).webkit.messageHandlers.swiftHandler;
    handler.postMessage(this.prepareIosEvent(name, data));
  }

  protected prepareIosEvent(
    name: string,
    data?: number | string | object
  ): { name: string; id?: number | string; url?: string; data?: object } {
    if (name === 'openUrl') {
      return { name, url: data as string };
    }
    if (typeof data === 'object' && data !== null) {
      return { name, data };
    }
    return { name, id: data as number | string };
  }

  protected sendAndroidEvent(): any {
    return (window as any).Android;
  }
}
